import script from "./AppNav.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppNav.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QSpinnerBall from 'quasar/src/components/spinner/QSpinnerBall.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSpinnerBall});
